<template>
    <div class="mainbox no footer">
        <Row>
            <Col class="link">
                <!-- <p><a href="" v-for=" nav in lang[local].footmenu ">{{nav}}</a></p> -->
                <p>Copyright © 2018~2020 Blockchain Venture Capital | All Rights Reserved</p>
            </Col>
            <!-- <Col span="6" class="imlink">
                <ul>
                    <li><a href="#"><i class="iconfont icon-QQ"></i></a></li>
                    <li><a href="#"><i class="iconfont icon-facebook"></i></a></li>
                    <li><a href="#"><i class="iconfont icon-tuitetwitter43"></i></a></li>
                    <li><a href="#"><i class="iconfont icon-ai-weixin"></i></a></li>
                </ul>
            </Col> -->
        </Row>
        
    </div>
</template>

<script>
import {mapState} from "vuex"
import {Row,Col} from "iview"
export default {
    components:{
        Row,Col
    },
    data () {
        return{
            
        }
    },
    computed:
        mapState(['lang','local'])
    ,
    mounted () {

    },
    methods:{

    }
    // render (h) {
    //     return (
    //     )
    // }
}
</script>

<style lang="less" scoped>
    .footer{
        font-size:14px;
        margin-top:30px;
        // line-height:32px;
        height:60px;
        color:#999;
        .link a{
            color:#999;
            font-weight:bold;
            padding-right:25px;
            margin-right:25px;
            border-right:1px solid #999;
            &:last-child{
                border-right:none;
            }
        }
        .imlink{
            li{
                float: right;list-style:none;
                margin:15px 10px;
                i{
                    font-size:30px;
                }
            }
            a{color:#999;}
        }
    }
</style>

